import Entrance from './Entrance.vue';

export default Entrance;
